import { render, staticRenderFns } from "./RegistrosLectorasrfid.vue?vue&type=template&id=6ccd49df&"
import script from "./RegistrosLectorasrfid.vue?vue&type=script&lang=js&"
export * from "./RegistrosLectorasrfid.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosLectorasrfid.vue?vue&type=style&index=0&id=6ccd49df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports